import React from "react"
import { getConnectionType, NodeCaption, NodeWindow, NodeContent, NodeWrapper, HandleInput, HandleOutputWrapper } from "../";

export const NodeBase = React.memo((props) => {

  const { id, data } = props;
  const { bgColor, label, content, connectionType, onEdit, onRemove } = data;
  const { isConnectable, input, handles } = getConnectionType(connectionType, true);

  return (
    <NodeWrapper bgColor={bgColor}>
      {input &&
        <HandleInput isConnectable={isConnectable}/>
      }
      <NodeWindow 
        caption={
          <NodeCaption title={label} onClickEdit={()=>onEdit(props)} onClickRemove={()=>onRemove(props)}/>
        }
      >
        {content && 
          <NodeContent>
            {content}
          </NodeContent>
        }
      </NodeWindow>
      <HandleOutputWrapper 
        handles={handles}
        isConnectable={isConnectable}
      />
    </NodeWrapper>
  );
});


